const key = 'subcategories';

import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';

import reducer, * as actions from './modules';
import { injectReducer } from '../../../store/reducers';
import PageComponent from '../../../components/PageComponent';
import Table from '../../../components/widgets/etable/custom';
import Props from '../../../components/widgets/etable/props';

class Subcategories extends PageComponent {
  static propTypes = Props;
  getAuthType = () => ['admin'];
  renderPage() {
    const { props } = this;
    const options = Object.assign({}, props, {
      editKey: 'admin/subcategories',
      legend: [{
        key: 'name',
        label: 'Name'
      }, {
        key: 'icon',
        className: 'text-muted',
        fn: icon => <span className={`pt-icon pt-icon-${icon}`} />,
        label: 'Icon'
      }, {
        key: 'active',
        className: 'text-muted',
        fn: active => active ? 'Yes' : 'No',
        label: 'Active'
      }]
    });

    return <section className="pad_2 content-width">
      <h2 className="m-b-2">Subcategories</h2>
      {React.createFactory(Table)(options)}
    </section>;
  }
}

export default store =>
  ({
    path: `/admin/subcategories`,
    getComponent(next, cb) {
      injectReducer(store, { key, reducer });
      cb(
        null,
        connect(state => ({ ...state, ...state[key] }), actions)(Subcategories)
      );
    }
  });

